"use client"

const FooterSkeleton = () => {
  return (
    <footer className="bg-[#F7F7F7] text-gray-700 border-t border-[#E5E5EA]">
      <div className="container mx-auto w-full max-w-[1128px] px-4 min-[1180px]:px-0 min-[1180px]:w-[1128px]">
        {/* Top Section: Logo và Slogan */}
        <div className="min-[1180px]:pt-12 min-[1180px]:pb-5 text-center pt-16 pb-4">
          <div className="flex flex-col gap-2.5 items-center">
            <div className="h-10 w-[170px] min-[1180px]:w-[200px] bg-gray-200 rounded animate-pulse" />
            <div className="h-4 w-64 bg-gray-200 rounded animate-pulse" />
          </div>
        </div>

        {/* Middle Section: Mobile 2 cột x 3 hàng, Desktop 5 cột */}
        <div className="pt-8 pb-16 min-[1180px]:pt-7 min-[1180px]:pb-12">
          {/* Mobile: 2 cột x 3 hàng */}
          <div className="grid grid-cols-2 gap-y-8 gap-x-4 min-[1180px]:hidden">
            {Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className="h-6 w-24 bg-gray-200 rounded animate-pulse" />
            ))}
            <div className="flex flex-col gap-3">
              <div className="h-5 w-32 bg-gray-200 rounded animate-pulse" />
              <div className="h-5 w-40 bg-gray-200 rounded animate-pulse" />
              <div className="h-5 w-48 bg-gray-200 rounded animate-pulse" />
            </div>
          </div>

          {/* Desktop: 5 cột */}
          <div className="hidden min-[1180px]:grid min-[1180px]:[grid-template-columns:20.83%_16.67%_16.67%_16.67%_29.18%] max-w-7xl mx-auto justify-start">
            {Array.from({ length: 5 }).map((_, colIndex) => (
              <div key={colIndex} className="flex flex-col gap-3 pl-2">
                {Array.from({ length: colIndex === 4 ? 3 : 4 }).map((_, index) => (
                  <div key={index} className="h-6 w-24 bg-gray-200 rounded animate-pulse" />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="border-t border-gray-200">
        <div className="container mx-auto w-full max-w-[1128px] px-4 min-[1180px]:px-0 min-[1180px]:w-[1128px] pt-4 pb-9 min-[1180px]:py-[0.8125rem]">
          <div className="flex flex-col min-[1180px]:flex-row justify-between items-center min-[1180px]:items-center gap-4">
            <div className="h-4 w-64 bg-gray-200 rounded animate-pulse" />
            <div className="flex gap-3.5">
              <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse" />
              <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default FooterSkeleton
